<template>
  <div :class="$style['pt-lab-order-form']">
    <pt-sub-title title="委托单信息" :showCollapse="false"></pt-sub-title>
    <pt-form-item label="委托单编号：" :labelWidth="labelWidth">
      <!-- <el-input :disabled="billDisabled" placeholder="请填写委托单编号" v-model="form.billCode"></el-input> -->
      <el-button plain type="primary" @click="showBillDialog = true">选择已有委托单</el-button>
      <el-button plain type="primary" @click="deleteSelectedBill">移除已选委托单</el-button>
    </pt-form-item>
    <pt-form-item label="委托方：" :labelWidth="labelWidth" v-if="form.clientOrganizationId && currentClient && currentClient.base">
      <!-- <el-button plain type="primary" :disabled="billDisabled" @click="selectClient">点击选择</el-button> -->
      <wt-input v-model="form.clientOrganizationId" style="display:none"></wt-input>
      <div :class="$style['package-table-div']" class="page-background" v-if="form.clientOrganizationId && currentClient && currentClient.base">
        <table :class="$style['package-table']">
          <th>
          <td>委托方单位名称</td>
          <td>社会统一信用代码</td>
          <td>联系人</td>
          <td>手机号</td>
          <td>操作</td>
          </th>
          <tr>
            <td>{{currentClient.base.name}}</td>
            <td>{{currentClient.base.secCode}}</td>
            <td>{{currentClient.base.contact}}</td>
            <td>{{currentClient.base.mobile}}</td>
            <td>
              <el-button type="text" @click="deleteClient" :disabled="billDisabled">移除</el-button>
            </td>
          </tr>
        </table>
      </div>
    </pt-form-item>
    <pt-form-item label="检测项目：" :labelWidth="labelWidth" :required="true" v-if="form.labExamItemId">
      <!-- <el-button plain type="primary" @click="selectProduct" :disabled="billExamItemsDisabled">点击选择</el-button> -->

      <wt-input v-model="form.labExamItemId" style="display:none" v-validate="'required'" data-vv-as="检测项目"></wt-input>

      <div :class="$style['package-table-div']" class="page-background" v-if="form.labExamItemId">
        <table :class="$style['package-table']">
          <th>
          <td>检测项目编号</td>
          <td>检测项目名称</td>
          <td>检测依据</td>
          <td>检测周期</td>
          <td>是否有偏离</td>
          <td>偏离原因</td>
          <td>相关文献</td>
          <td>操作</td>
          </th>
          <tr v-for="(item,index) in billExamItems" :key="index">
            <td>{{item.itemVersion}}</td>
            <td>{{item.itemName}}</td>
            <td>{{item.examBasis&&item.examBasis.name}}</td>
            <td>{{item.testCycle && item.dayType ? (item.testCycle.replace(/[^0-9]/ig, '') + getdayType(item.dayType)) : '-'}}</td>
            <td>{{item.deviate?'是':"否"}}</td>
            <td>{{item.deviateInfo}}</td>
            <td>
              <wt-upload-file :action="uploadApi" :data="picture_params" :img-url="privateResourcesUrl" listType="text" v-model="item.attachments" :class="$style['dialog-upload']">
              </wt-upload-file>
            </td>
            <td>
              <el-button type="text" @click="deleteLabProduct">移除</el-button>
            </td>
          </tr>
        </table>
      </div>
    </pt-form-item>
    <!-- <pt-form-item label="检测依据：" :labelWidth="labelWidth">
      <el-input placeholder="请填写检测依据" v-model="form.examBasis"></el-input>
    </pt-form-item>
    <pt-form-item label="是否有偏离：" :labelWidth="labelWidth">
      <el-select :disabled="billDisabled" v-model="form.deviate" placeholder="请选择是否有偏离">
        <el-option label="是" :value="true"></el-option>
        <el-option label="否" :value="false"></el-option>
      </el-select>
      <span style="display:inline-block;width:20px"></span>
      <el-input :disabled="billDisabled" placeholder="请填写详细情况描述" v-model="form.deviateInfo"></el-input>
    </pt-form-item> -->

    <pt-sub-title title="样品信息"></pt-sub-title>
    <pt-form-item label="检测项目：" :labelWidth="labelWidth" :required="true">
      <el-button plain type="primary" @click="selectProductSample">点击选择</el-button>
      <div :class="$style['package-table-div']" class="page-background" v-if="form.labExamItemIdSample">
        <table :class="$style['package-table']">
          <th>
          <!-- <td>检测项目编号</td> -->
          <td>检测项目名称</td>
          <td>检测依据</td>
          <td>检测周期</td>
          <td>是否有偏离</td>
          <td>偏离原因</td>
          <td>相关文献</td>
          <td>操作</td>
          </th>
          <tr v-for="(item,index) in form.labExamItems" :key="index">
            <!-- <td>{{item.itemVersion}}</td> -->
            <td>{{item.itemName}}</td>
            <td>{{item.examBasis&&item.examBasis.name}}</td>
            <td>{{item.testCycle && item.dayType ? item.testCycle.replace(/[^0-9]/ig, '') + getdayType(item.dayType) : '-'}}</td>
            <td>{{item.deviate?'是':"否"}}</td>
            <td>{{item.deviateInfo}}</td>
            <td>
              <wt-upload-file :action="uploadApi" :data="picture_params" :img-url="privateResourcesUrl" listType="text" v-model="item.attachments" :class="$style['dialog-upload']">
              </wt-upload-file>
            </td>
            <td>
              <!-- <el-button type="text" @click="deleteLabProduct">移除</el-button> -->
            </td>
          </tr>
        </table>
      </div>
    </pt-form-item>
    <!-- <pt-form-item label="上传文献：" :labelWidth="labelWidth">
      <wt-upload-file :action="uploadApi" :data="picture_params" :img-url="privateResourcesUrl" listType="text" v-model="form.attachments" :class="$style['dialog-upload']">
        <el-button size="small" type="primary">点击上传</el-button>
      </wt-upload-file>
    </pt-form-item> -->
    <pt-form-item label="样品编号：" :labelWidth="labelWidth">
      <el-input v-model="form.orderCode" data-vv-as="样品编号" placeholder="请填写样品编号"></el-input>
    </pt-form-item>
    <pt-form-item label="样品名称：" :labelWidth="labelWidth" :required="true">
      <el-input v-model="form.orderName" data-vv-as="样品名称" v-validate="'required'" placeholder="请填写样品名称"></el-input>
    </pt-form-item>
    <pt-form-item label="客户编号：" :labelWidth="labelWidth">
      <el-input v-model="form.customerCode" data-vv-as="客户编号" placeholder="请填写客户编号"></el-input>
    </pt-form-item>
    <pt-form-item label="生产单位：" :labelWidth="labelWidth">
      <el-input v-model="form.productionUnit" placeholder="请填写生产单位"></el-input>
    </pt-form-item>
    <pt-form-item label="生产日期：" :labelWidth="labelWidth">
      <el-input v-model="form.orderProductDate" placeholder="请填写生产日期"></el-input>
      <!-- <el-date-picker v-model="form.orderProductDate" type="date" placeholder="选择日期"></el-date-picker> -->
    </pt-form-item>
    <pt-form-item label="生产批次：" :labelWidth="labelWidth">
      <el-input v-model="form.productBatchCode" placeholder="请填写生产批次"></el-input>
    </pt-form-item>
    <pt-form-item label="商标：" :labelWidth="labelWidth">
      <el-input v-model="form.brand" placeholder="请填写商标"></el-input>
    </pt-form-item>
    <pt-form-item label="规格/型号：" :labelWidth="labelWidth">
      <wt-selector v-model="form.specificationModel" allowCreate filterable :options="models" placeholder="请填写规格/型号"></wt-selector>
    </pt-form-item>
    <!-- <pt-form-item label="数量：" :labelWidth="labelWidth">
      <el-input v-model="form.orderCount" :disabled="recollect" placeholder="请填写数量"></el-input>
    </pt-form-item> -->
    <pt-form-item label="颜色：" :labelWidth="labelWidth">
      <wt-selector v-model="form.color" allowCreate filterable :options="colors" placeholder="请填写颜色"></wt-selector>
    </pt-form-item>
    <pt-form-item label="形态：" :labelWidth="labelWidth" >
      <wt-selector data-vv-as="形态" v-model="form.shapes" multiple allowCreate filterable :options="shapes" placeholder="请填写形态"></wt-selector>
    </pt-form-item>
    <pt-form-item label="包装：" :labelWidth="labelWidth" >
      <wt-selector data-vv-as="包装" v-model="form.pack" allowCreate filterable :options="packs" placeholder="请填写包装" ></wt-selector>
    </pt-form-item>
    <pt-form-item label="存放条件：" :labelWidth="labelWidth" :required="true">
      <wt-selector data-vv-as="存放条件" v-model="form.storage_show" v-validate="'required'" allowCreate filterable :options="storages" placeholder="请填写存放条件" multiple></wt-selector>
    </pt-form-item>
    <pt-form-item label="交付方式：" :labelWidth="labelWidth">
      <wt-selector :disabled="billDisabled" data-vv-as="交付方式" v-model="form.deliveryType" :options="terrace" :multiple="true" placeholder="请选择交付方式"></wt-selector>
    </pt-form-item>
    <pt-form-item label="报告份数：" :labelWidth="labelWidth">
      <el-input placeholder="请填写报告份数" v-model="form.reportNum"></el-input>
    </pt-form-item>
    <pt-form-item label="交付日期：" :labelWidth="labelWidth">
      <el-date-picker :disabled="billDisabled" v-model="form.deliveryDate" type="date" placeholder="选择日期" data-vv-as="交付日期"></el-date-picker>
    </pt-form-item>
    <pt-form-item label="是否返还：" :labelWidth="labelWidth" :required="true">
      <el-radio-group  :disabled="billDisabled" v-model="form.back" data-vv-as="是否返还" v-validate="'required'">
        <el-radio :label="true">是</el-radio>
        <el-radio :label="false">否</el-radio>
      </el-radio-group>
    </pt-form-item>
    <pt-form-item label="是否加急：" :labelWidth="labelWidth">
      <el-radio-group :disabled="billDisabled" v-model="form.urgent">
        <el-radio :label="true">是</el-radio>
        <el-radio :label="false">否</el-radio>
      </el-radio-group>
    </pt-form-item>
    <!-- <pt-form-item label="加急费（元）：" :labelWidth="labelWidth">
      <el-input :disabled="billDisabled" placeholder="请填写加急费用" v-model="form.urgentMoney"></el-input>
    </pt-form-item>
    <pt-form-item label="合计总金额：" :labelWidth="labelWidth">
      <el-input :disabled="billDisabled" placeholder="请填写合计总金额" v-model="form.billAmount"></el-input>
    </pt-form-item> -->
    <pt-form-item label="备注：" :labelWidth="labelWidth">
      <el-input v-model="form.remarks" placeholder="请填写备注" type="textarea"></el-input>
    </pt-form-item>
    <!-- 选择委托单 -->
    <select-bill-dialog :dialogVisible="showBillDialog" @close="showBillDialog = false" @selectData="getBill" :pageSize="5" :selectedKeys="form.billId"></select-bill-dialog>

    <!-- 选择委托方 -->
    <select-client-dialog :dialogVisible="showClientDialog" @close="closeClientDialog" @selectData="getClient" :pageSize="5" :selectedKeys="form.clientOrganizationId"></select-client-dialog>

    <!-- 选择检测项目 -->
    <select-lab-product :productList="billExamItems" :noQuery="selectedBill" :dialogVisible="showDialog" @close="closeDefaultDialog" @selectData="selectData" selectType="checkbox" :pageSize="5" :selectedKeys="selectedExamIds" :isDialog="!selectedBill"></select-lab-product>
  </div>
</template>

<script>
// 组件class前缀
import organizationSelector from 'cps/selector/organization-selector.vue'
import wtUploadBigFile from 'cps/common/wt-upload-big-file'
// import ptAddressSelect from 'cps/base/pt-address-select/withData'
import selectClientDialog from 'cps/trust-deed/pt-trust-deed-form/select-client-dialog.vue'
import selectBillDialog from './select-bill-dialog.vue'
import selectLabProduct from 'cps/trust-deed/pt-trust-deed-form/select-lab-product.vue'
// import ptProvinceSelect from 'cps/base/pt-province-select'
import arrayInput from 'cps/common/array-input'
import formMixins from 'mixins/form'
import { isRequired } from './form-required-option'
import {
  getdayType
} from 'enumeration/lab-order.js'
import {
  terrace
} from 'json/lab-order'
import {
  colors,
  storages,
  shapes,
  models,
  packs
} from 'json/trust-deed'

const prefixCls = 'pt-lab-order-form'
export default {
  name: 'pt-lab-order-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    },
    billDisabled () {
      return !!this.form.billId
    },
    selectedBill () {
      return !!this.form.billId// 如果已选择委托单，检测项目只能选择委托单中的检测项目（并且不能编辑检测依据等），否则选择全部。
    }
  },
  props: {
    value: {
      type: Object,
      default: () => { }
    },
    bill: {
      type: Object,
      default: () => { }
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    recollect: {
      type: Boolean,
      default: false
    }
  },
  components: {
    // ptAddressSelect,
    organizationSelector,
    wtUploadBigFile,
    arrayInput,
    selectClientDialog,
    selectLabProduct,
    selectBillDialog
  },
  data () {
    return {
      terrace,
      colors,
      storages,
      shapes,
      models,
      packs,
      labelWidth: '170px',
      form: this.value.id ? this.value : {
        billId: '',
        urgent: false,
      },
      showDialog: false,
      showClientDialog: false,
      showBillDialog: false,
      currentClient: {},
      currentProduct: {},
      agentData: {},
      sampleTypes: [],
      uploadApi: this.$uploadApi,
      picture_params: {
        resourceName: 'literature',
        objectId: this.value?.id || 0
      },
      privateResourcesUrl: this.$privateResourcesUrl,
      billExamItems: [],
      billExamItemsDisabled: false,
      selectedExamIds: []
    }
  },
  watch: {
    value (val) {
      this.form = JSON.parse(JSON.stringify(val))
			this.form.pack_show=this.form.pack?.split(',')
			this.form.storage_show=this.form.storage?.split(',')
			this.form.labExamItems = [val.labExamItem]
			this.form.labExamItemIdSample = val.labExamItem.id
			this.selectedExamIds = [val.labExamItem.id]
    },
    bill (val) {
      this.currentClient = val?.organization || {}
			this.billExamItems=val.labExamItemList
			this.form.labExamItemId=val.labExamItemList && val.labExamItemList[0] && val.labExamItemList[0].id
			this.form.billId=val.id
			this.$set(this.form,'deliveryType',val.deliveryType)
    },
    form (val) {
      this.$emit('input', JSON.parse(JSON.stringify(val)))
    }
  },
  methods: {
    deleteSelectedBill () {
			this.form.billId=null
      this.$delete(this.form, 'billCode')
      this.$delete(this.form, 'labExamItem')
      this.billExamItemsDisabled = false
      this.$delete(this.form, 'clientOrganizationId')
      this.$delete(this, 'billExamItems')
      this.$delete(this.form, 'labExamItemId')
      this.$delete(this.form, 'deliveryType')
      this.$delete(this.form, 'deliveryDate')
      this.$delete(this.form, 'back')
      this.$delete(this.form, 'urgent')
			this.$delete(this.form, 'reportNum')
    },
    getdayType,
    getStatus (val) {
      this.$emit('isUpload', val)
    },
    cancel () {
      history.go(-1)
    },
    selectClient () {
      this.showClientDialog = true
    },
    closeClientDialog () {
      this.showClientDialog = false
    },
    closeDefaultDialog () {
      this.showDialog = false
    },
    selectProduct () {
      this.showDialog = true
    },
    selectProductSample () {
      this.showDialog = true
    },
    closeDefaultDialog () {
      this.showDialog = false
    },
    getClient (val) {
      this.currentClient = val

      this.closeClientDialog()
    },
    deleteClient () {
      this.$delete(this.form, 'clientOrganizationId')
    },
    deleteLabProduct () {
      this.$delete(this.form, 'labExamItemId')
    },
    getBill (val) {
			const { deviate, deviateInfo, deliveryType, reportNum, deliveryDate, back, urgent, urgentMoney, billAmount, remarks } = val
			this.form.billId = val.id
			this.$set(this.form,'billId',val.id)
      this.form.billCode = val.billCode
      this.form = Object.assign(this.form, { deviate, deviateInfo, deliveryType, reportNum, deliveryDate, back, urgent, urgentMoney, billAmount, remarks })
      this.form.clientOrganizationId = val.organization.id
      this.currentClient = val.organization
      this.labExamItem = val.labExamItemList || []
      this.billExamItemsDisabled = true
			this.billExamItems = val.labExamItemList
      this.form.labExamItemId = val.labExamItemList && val.labExamItemList[0] && val.labExamItemList[0].id
      this.showBillDialog = false
    },
    selectData (val) {
      // this.form.labExamItemId = val.id
      this.form.labExamItemIdSample = val && val[0] && val[0].id
			this.form.labExamItems = val
			this.selectedExamIds=val.map(item=>item.id)
      this.closeDefaultDialog()
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-lab-order-form {
  :global {
    .el-input,
    .el-input__inner {
      max-width: 2.8rem;
    }
    .el-input--suffix .el-input__inner {
      min-width: 2.8rem;
    }
    .el-upload--picture-card,
    .el-upload-list--picture-card .el-upload-list__item {
      width: 117px;
      height: 155px;
    }
    el-textarea,
    .el-textarea__inner {
      width: 500px;
      font-family: "Microsoft YaHei", "微软雅黑", "Avenir", Helvetica, Arial;
    }
    .wt-upload-file {
      line-height: 0;
			margin-top: 0;
			.el-upload-list__item:first-child{
			margin-top: 0;
			}
    }
  }
  .age {
    :global {
      .el-input--suffix .el-input__inner {
        min-width: 1.5rem;
      }
    }
  }
  .address {
    :global {
      .el-select .el-input,
      .el-input__inner {
        height: 0.4rem !important;
      }
    }
  }
  .upload-file-text {
    line-height: 155px;
  }
  .dashed {
    margin: 30px 0;
    height: 1px;
    background-image: linear-gradient(
      to right,
      #ccc 0%,
      #ccc 50%,
      transparent 50%
    );
    background-size: 8px 1px;
    background-repeat: repeat-x;
  }
  .package-table-div {
    margin-top: 10px;
    padding: 10px 20px 30px;
    max-width: 800px;
  }
  .package-table {
    display: table !important;
    width: 100%;
    border-collapse: collapse !important;
    th,
    tr {
      width: 100% !important;
      max-width: 100% !important;
      display: table-row;
      padding: 0 !important;
      list-style-type: none;
      border-bottom: 1px solid #c6c9d3;
      color: #818181;
    }
    td {
      text-align: center;
    }
  }
}
</style>
